import React from 'react';
import { IconLookup } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCcAmex, faCcDiscover, faCcMastercard, faCcPaypal, faCcVisa } from '@fortawesome/free-brands-svg-icons';

/**
 * The card marks, from `includes/modules/footer/cards.html` — the same five, in the
 * order that template lists them.
 *
 * Drawn from the icon set rather than the brand's own SVGs, which is what both existing
 * brands' footers do (TopMags' came off a `payment-icons.png` sprite and DiscountMags'
 * off its own images). Keeping to one source is what stops a sixth brand needing a sixth
 * set of assets.
 *
 * Not in `shared/Layouts/Full/Footer` beside FooterMenu, unlike the columns above it: all
 * four brands draw the same five marks in four different orders, each its own legacy
 * image's, so sharing this means picking one brand's order for everyone. That is a
 * decision worth taking on its own rather than inside a port.
 */
export default function AcceptedPaymentMethods() {
  const paymentMethods: { icon: IconLookup }[] = [
    { icon: faCcAmex },
    { icon: faCcVisa },
    { icon: faCcMastercard },
    { icon: faCcDiscover },
    { icon: faCcPaypal },
  ];

  return (
    <ul className="m-0 flex list-none justify-center gap-2 p-0">
      {paymentMethods.map(({ icon }, index) => (
        <li key={index}>
          <FontAwesomeIcon icon={icon} size="2x" className="text-slate-500" />
        </li>
      ))}
    </ul>
  );
}
